const ApiBase = "https://kalendarium.feuerwehrstadthagen.de";

const Config = {
  ApiBase,
  LoginURL: `${ApiBase}/login.php`,
  SessionURL: `${ApiBase}/auth_session.php`,
  LogoutURL: `${ApiBase}/auth_logout.php`,
  OIDCLoginURL: `${ApiBase}/auth_login.php` // startet Redirect zum Keycloak-Manager
};

export default Config;
